import { NgModule } from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';

/*PRIME NG MODULES*/
import {DialogModule} from "primeng/dialog";
import {DropdownModule} from "primeng/dropdown";
import {InputTextModule} from "primeng/inputtext";
import {ButtonModule} from "primeng/button";
import {RadioButtonModule} from "primeng/radiobutton";
import {RippleModule} from "primeng/ripple";
import {SliderModule} from "primeng/slider";
import {InputNumberModule} from "primeng/inputnumber";
import {MessagesModule} from "primeng/messages";
import {MessageModule} from "primeng/message";
import {ToastModule} from "primeng/toast";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {CardModule} from "primeng/card";
import {SidebarModule} from "primeng/sidebar";
import {PanelMenuModule} from "primeng/panelmenu";
import {TabMenuModule} from "primeng/tabmenu";
import {AvatarModule} from "primeng/avatar";
import {BadgeModule} from "primeng/badge";
import {BreadcrumbModule} from "primeng/breadcrumb";
import {AccordionModule} from "primeng/accordion";
import {TableModule} from "primeng/table";
import {CalendarModule} from "primeng/calendar";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {TabViewModule} from "primeng/tabview";
import {ChartModule} from "primeng/chart";
import {SelectButtonModule} from "primeng/selectbutton";
import {TagModule} from "primeng/tag";
import {SkeletonModule} from "primeng/skeleton";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {LibraryModule} from "library";
import {InputMaskModule} from "primeng/inputmask";
import {InputSwitchModule} from "primeng/inputswitch";
import {CheckboxModule} from "primeng/checkbox";
import {ScrollPanelModule} from "primeng/scrollpanel";
import {ListboxModule} from "primeng/listbox";
import {PanelModule} from "primeng/panel";
import {AutoCompleteModule} from "primeng/autocomplete";
import {TriStateCheckboxModule} from "primeng/tristatecheckbox";
import {DividerModule} from "primeng/divider";
import {MultiSelectModule} from "primeng/multiselect";
import {PaginatorModule} from "primeng/paginator";
import {CarouselModule} from "primeng/carousel";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MessagesModule,
    MessageModule,
    ToastModule,
    ButtonModule,
    InputTextModule,
    ProgressSpinnerModule,
    CardModule,
    SidebarModule,
    PanelMenuModule,
    DialogModule,
    TabMenuModule,
    AvatarModule,
    BadgeModule,
    BreadcrumbModule,
    AccordionModule,
    TableModule,
    CalendarModule,
    ConfirmDialogModule,
    TabViewModule,
    ChartModule,
    RippleModule,
    SelectButtonModule,
    DropdownModule,
    TagModule,
    SkeletonModule,
    SliderModule,
    FontAwesomeModule,
    LibraryModule,
    RadioButtonModule,
    InputMaskModule,
    InputSwitchModule,
    CheckboxModule,
    ScrollPanelModule,
    ListboxModule,
    TagModule,
    PanelModule,
    AutoCompleteModule,
    InputNumberModule,
    TriStateCheckboxModule,
    DividerModule,
    MultiSelectModule,
    PaginatorModule,
    MessagesModule,
    MessageModule,
    CarouselModule
  ],
  exports: [
    CommonModule,
    MessagesModule,
    MessageModule,
    ToastModule,
    ButtonModule,
    InputTextModule,
    ProgressSpinnerModule,
    CardModule,
    SidebarModule,
    PanelMenuModule,
    DialogModule,
    TabMenuModule,
    AvatarModule,
    BadgeModule,
    BreadcrumbModule,
    AccordionModule,
    TableModule,
    CalendarModule,
    ConfirmDialogModule,
    TabViewModule,
    ChartModule,
    RippleModule,
    SelectButtonModule,
    DropdownModule,
    TagModule,
    SkeletonModule,
    SliderModule,
    FontAwesomeModule,
    LibraryModule,
    RadioButtonModule,
    InputMaskModule,
    InputSwitchModule,
    CheckboxModule,
    ScrollPanelModule,
    ListboxModule,
    TagModule,
    PanelModule,
    AutoCompleteModule,
    InputNumberModule,
    TriStateCheckboxModule,
    DividerModule,
    MultiSelectModule,
    PaginatorModule,
    MessagesModule,
    MessageModule,
    CarouselModule
  ],
})
export class PrimengModule { }
